import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { FormattedMessage } from "react-intl";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Box from "@material-ui/core/Box";
import ButtonBase from "@material-ui/core/ButtonBase";
import { MemberStatus } from "../../settings/MemberStatus";

const useStyles = makeStyles((theme) => ({
  normal: {
    padding: 0,
  },
  selected: {
    backgroundColor: "#D6E6FF",
    padding: 0,
  },
  leftPart: {
    paddingLeft: 20,
  },
  rightPart: {
    paddingRight: 20,
  },
  name: {
    fontSize: 14,
    fontWeight: "bold",
    marginRight: 2,
  },
  profile: {
    fontSize: 14,
    color: theme.palette.grey[500],
  },
  new: {
    fontSize: 12,
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  pending: {
    fontSize: 12,
    color: "#F2994A",
    fontWeight: "bold",
  },
  approved: {
    fontSize: 12,
    color: "#219653",
    fontWeight: "bold",
  },
  baseButton: {
    width: "100%",
  },
}));

interface TeamMemberSearchResultItemProps {
  name: string;
  profile: string;
  status: MemberStatus;
  selected: boolean;
  onClick: () => void;
}

export const TeamMemberSearchResultItem = (
  props: TeamMemberSearchResultItemProps
) => {
  const classes = useStyles();
  const { name, profile, status, selected, onClick } = props;

  return (
    <Grid
      item
      xs={12}
      lg={12}
      className={selected ? classes.selected : classes.normal}
    >
      <ButtonBase className={classes.baseButton} onClick={onClick}>
        <Box
          borderTop={0.7}
          borderBottom={1}
          borderColor="grey.200"
          display="flex"
          justifyContent="center"
          width="100%"
          height="50px"
        >
          <Grid container item xs={12} lg={12}>
            <Grid
              container
              item
              xs={9}
              lg={9}
              className={classes.leftPart}
              direction="row"
              alignItems="center"
            >
              <Typography className={classes.name} variant="h4" component="h4">
                {name}
              </Typography>
              <Typography
                className={classes.profile}
                variant="h4"
                component="h4"
              >
                ({profile})
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={3}
              lg={3}
              direction="row"
              alignItems="center"
              justify="space-between"
              className={classes.rightPart}
            >
              <Typography
                className={
                  status === MemberStatus.approved
                    ? classes.approved
                    : status === MemberStatus.new
                    ? classes.new
                    : classes.pending
                }
                variant="h4"
                component="h4"
              >
                {status === MemberStatus.approved ? (
                  <FormattedMessage id="sharedScreen.approved" />
                ) : status === MemberStatus.new ? (
                  <FormattedMessage id="sharedScreen.new" />
                ) : (
                  <FormattedMessage id="sharedScreen.pending" />
                )}
              </Typography>
              <NavigateNextIcon />
            </Grid>
          </Grid>
        </Box>
      </ButtonBase>
    </Grid>
  );
};
